/**
 * 引入一些工具函数
 */
import '@utils/extendPrototype'
import '@/utils/resize'
